module.exports = __webpack_public_path__ + "img/e222d02118002c68a3361addec72c8d1.png";